import React from "react";

export default ({ className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="200"
    height="40"
    viewBox="0 0 711.4 133.1"
    className={className}
  >
    <path
      fill="#3730A3"
      d="M0 38.2h39c10 0 18-8.1 18-18V.2H19l-8.2 16.5zM39.1 57.2h-20v75.9h38.1V75.3c-.1-10-8.2-18.1-18.1-18.1zM75.1.1v20c0 10 8.1 18 18 18h47l19-38.1h-84zM75.1 75v20h36.6l19-38.1H93.1c-9.9 0-18 8.1-18 18.1z"
    />
    <g>
      <path d="M211.1 49.5v13.2h25.5v11.4h-25.5v21h-14.5V38.3h42.1v11.4h-27.6zM321.2 79h-11.4v16h-14.5V38.2h25.4c15 0 23.6 7.1 23.6 19.8 0 8.7-3.7 14.9-10.3 18.3l11.9 18.8h-16.4zm-.4-11.4c6.3 0 9.9-3.2 9.9-9.2 0-5.9-3.7-8.9-9.9-8.9h-11v18.1zM406.5 43.8l-5.4 11.3c-6-3.5-13.6-5.9-18.2-5.9-3.7 0-6.3 1.4-6.3 4.1 0 9.8 30 4.2 30 24.8 0 11.4-10.1 17.4-22.7 17.4-9.5 0-19.2-3.6-26-9.1l5.6-11.1c5.8 5.1 14.6 8.5 20.5 8.5 4.5 0 7.4-1.7 7.4-5 0-10.1-30-4.1-30-24.2 0-10.5 9-17.1 22.7-17.1 8.2 0 16.6 2.5 22.4 6.3zM449 49.8V95h-14.5V49.8h-17V38.1h48.6v11.7zM563.6 38.2l-19 56.8h-8.5l-15.6-45.4L505 95h-8.7l-19-56.8h8.4L501 84.4l16-46.2h7.5l15.7 46.4 15.7-46.4zM630.5 38.2V95h-8.1V69.7h-32.7V95h-8.1V38.2h8.1v24.4h32.6V38.2zM651 66.6c0-16.6 12.8-29.1 30.3-29.1 17.3 0 30.1 12.3 30.1 29.1 0 16.7-12.8 29.1-30.1 29.1-17.5 0-30.3-12.5-30.3-29.1zm52.3 0c0-12.6-9.4-21.8-22-21.8-12.7 0-22.2 9.3-22.2 21.8s9.4 21.8 22.2 21.8c12.6 0 22-9.2 22-21.8zM261.4 95V49.5h-10.5V38.1h24.9v56.8h-14.4z" />
    </g>
  </svg>
);
